import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoggedUserClass, UserTokenClass } from '../models/users-class';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  GenerateToken(loggedUserClass: LoggedUserClass): Observable<string> {
    return this.http.post<string>(environment.URL + `/users/GenerateToken/`, loggedUserClass).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetUsersInitialPage(IdUser: number, navigateTo: string, uuid: string): Observable<boolean> {
    let dados = {
      idUser: IdUser,
      NavigateTo: navigateTo,
      UUIDLastChange: uuid,
    };

    return this.http.post<boolean>(environment.URL + `/users/SetUsersInitialPage/`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementGetUsers(): Observable<LoggedUserClass[]> {
    return this.http.get<LoggedUserClass[]>(environment.URL + `/users/ManagementGetUsers/`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetUsersPassword(passwordOld: string, passwordNew: string, nif: string, uuid: string): Observable<boolean> {
    let dados = {
      NIF: nif,
      PasswordOld: passwordOld,
      PasswordNew: passwordNew,
      UUIDLastChange: uuid,
    };

    return this.http.post<boolean>(environment.URL + `/users/SetUsersPassword`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetUserNIFExists(nif: string): Observable<LoggedUserClass> {
    return this.http.post<LoggedUserClass>(environment.URL + `/users/GetUserNIFExists`, { NIF: nif }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetUserEmailExists(email: string): Observable<string> {
    return this.http.post<string>(environment.URL + `/users/GetUserEmailExists`, { Email: email }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetUsersPasswordRestoreDefault(nif: string, password: string): Observable<string> {
    // tslint:disable-next-line:prefer-const
    let dados = {
      NIF: nif,
      Password: password,
    };

    return this.http.post<string>(environment.URL + `/users/SetUsersPasswordRestoreDefault`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetUsersPasswordRestore(email: string, nif: string, password: string): Observable<string> {
    // tslint:disable-next-line:prefer-const
    let dados = {
      Email: email,
      NIF: nif,
      Password: password,
    };

    return this.http.post<string>(environment.URL + `/users/SetUsersPasswordRestore`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetUserId(idUser: number): Observable<LoggedUserClass> {
    return this.http.post<LoggedUserClass>(environment.URL + `/users/GetUserId`, { idUser: idUser }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetUserTokenId(idUser: number): Observable<UserTokenClass[]> {
    return this.http.post<UserTokenClass[]>(environment.URL + `/users/GetUserTokenId`, { idUser: idUser }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  UsersNew(newUserClans: LoggedUserClass, uuid: string): Observable<LoggedUserClass[]> {
    newUserClans.UUIDLastChange = uuid;
    return this.http.post<LoggedUserClass[]>(environment.URL + `/users/UsersNew`, newUserClans).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetUsers(newUserClans: LoggedUserClass, uuid: string): Observable<LoggedUserClass[]> {
    newUserClans.UUIDLastChange = uuid;
    return this.http.post<LoggedUserClass[]>(environment.URL + `/users/SetUsers`, newUserClans).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementSetUsers(newUserClans: LoggedUserClass, uuid: string): Observable<LoggedUserClass> {
    newUserClans.UUIDLastChange = uuid;
    return this.http.post<LoggedUserClass>(environment.URL + `/users/ManagementSetUsers`, newUserClans).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementSetPermissions(userPermissions: any, uuid: string): Observable<LoggedUserClass[]> {
    userPermissions.UUIDLastChange = uuid;
    return this.http.post<LoggedUserClass[]>(environment.URL + `/users/ManagementSetPermissions`, userPermissions).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  /**
   * Permite admin fazer login como outro utilizador
   */
  ImpersonateUser(targetIdUser: number): Observable<any> {
    return this.http.post<any>(environment.URL + `/users/ImpersonateUser`, { targetIdUser }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  /**
   * Request password reset token
   */
  requestPasswordReset(nif: string): Observable<any> {
    return this.http.post<any>(environment.URL + `/security-tokens/password-reset`, { nif }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  // ==========================================
  // MAGIC LINK AUTHENTICATION
  // ==========================================

  MagicLinkRequest(nif: string, productName?: string): Observable<any> {
    const payload = { NIF: nif, ProductName: productName || 'Simulação/Compra' };
    return this.http.post<any>(environment.URL + `/users/MagicLinkRequest`, payload).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  MagicLinkCheckStatus(token: string): Observable<any> {
    return this.http.post<any>(environment.URL + `/users/MagicLinkCheckStatus`, { Token: token }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  MagicLinkConfirm(token: string): Observable<any> {
    // End-point para quem clica no email (geralmente GET ou com POST mas confirmando o Token)
    return this.http.post<any>(environment.URL + `/users/MagicLinkConfirm`, { Token: token }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
